import React, { Component, Fragment } from 'react'
import { OnboardingHeader } from 'components/OnboardingHeader'
import ProgressMeterWithLogo from 'components/ProgressMeterWithLogo'
import { Card } from '@drifthq/tide-core'
import BackButton from "components/OnboardingBackButton"
import DEMO_IMG from './message-bubble.svg'
import NEWSLETTER_IMG from './letter.svg'
import WEBINAR_IMG from './chat-with-bot.svg'
import { track } from 'utils/trackingUtils'

import './style.css'

export const PLAYBOOK_TYPES = Object.freeze({
  DEMO_REQUEST: "request-demo",
  NEWSLETTER: "newsletter-subscribe",
  WEBINAR: "webinar-signup"
})

class PickBot extends Component {

  trackPickBotOption = (playbookType) => {
    const { name, segment } = this.props

    track(`${name} Step - Option Clicked`, { key: playbookType, route: '/pick-bot', segment: segment })
    if (playbookType === PLAYBOOK_TYPES.DEMO_REQUEST) {
      track(`${name} Step - Continued`, { route: '/pick-bot', segment: segment })
    }
  }

  onDemoClick = () => {
    const { history, actions } = this.props
    actions.setPlaybookType(PLAYBOOK_TYPES.DEMO_REQUEST)
    history.push('/onboarding/demo')
  }

  onNewsletterClick = () => {
    const { actions, onContinue } = this.props
    actions.setPlaybookType(PLAYBOOK_TYPES.NEWSLETTER)
    onContinue()
  }
  
  onWebinarClick = () => {
    const { history } = this.props
    history.push('/onboarding/webinar')
  }

  FORM_OPTIONS = Object.freeze([
    {
      title: "Request a demo",
      imgSrc: DEMO_IMG,
      key: PLAYBOOK_TYPES.DEMO_REQUEST,
      clickHandler: this.onDemoClick
    },
    {
      title: "Subscribe to our newsletter",
      imgSrc: NEWSLETTER_IMG,
      key: PLAYBOOK_TYPES.NEWSLETTER,
      clickHandler: this.onNewsletterClick
    },
    {
      title: "Signup for a webinar",
      imgSrc: WEBINAR_IMG,
      key: PLAYBOOK_TYPES.WEBINAR,
      clickHandler: this.onWebinarClick
    }
  ])

  onOptionClick = ({ clickHandler, key }) => {
    clickHandler()
    this.trackPickBotOption(key)
  }

  render() {
    const { index, stepCount } = this.props
    return (
      <Fragment>
        <ProgressMeterWithLogo currentLength={index} maxLength={stepCount - 1} />
        <OnboardingHeader
          title="What’s the goal of this bot?"
        />
        <span className="pick-bot-card-row">
          {this.FORM_OPTIONS.map(({ title, imgSrc, key, clickHandler }) =>
            <Card className="pick-bot-card"
              onClick={() => this.onOptionClick({ clickHandler, key })}
              key={key}
              header={title}
              imgSrc={imgSrc}/>)
          }
        </span>
        <BackButton />
      </Fragment>
    )
  }
}

export default PickBot


// WEBPACK FOOTER //
// ./src/layouts/OnboardingPlaybookPickBotStep/index.js